import { BrowserRouter, Route, Routes } from "react-router-dom";
import SignIn from "./pages/authentication/signin";

import ResetPassword from "./pages/authentication/reset-password";
import UpdatePassword from "./pages/authentication/update-password";
import Signup from "./pages/authentication/signup";
import PractitionerDashboard from "./pages/practitioner/practitioner-dashboard";
import PatientDashboard from "./pages/patient/patient-dashboard";
import AdminDashboard from "./pages/admin/admin-dashboard";
import AppointmentPage from "./pages/practitioner/appointment-page";
import ProfilePage from "pages/practitioner/profile-page";
import SignOut from "pages/authentication/signout";
import ConfigurationsHome from "pages/admin/configurations/configurations-home";
import AdminCalendar from "pages/admin/calendar/admin-calendar";

import ProtectedRoute from "lib/components/layouts/protected-route";
import PractitionerSubscriptionPage from "pages/practitioner/subscriptions/practitioner-subscription-page";
import DashboardAppointmentsPage from "pages/admin/dashboard/appointments/dashboard-appointments-page";
import DashboardOccupancyPage from "pages/admin/dashboard/occupancy/dashboard-occupancy-page";
import DashboardSubscriptionPage from "pages/admin/dashboard/subscriptions/dashboard-subscription-page";
import PractitionerSignup from "pages/authentication/practitioner-signup";
import UpsertSubscriptions from "pages/admin/configurations/subscription/upsert-subscriptions";
import PractitionerAddAppointmentPage from "./pages/practitioner/add-appointments";
import PatientBookAppointmentPage from "pages/patient/book-appointment-page";
import PatientConfirmAppointmentPage from "pages/patient/confirm-appointment-page";
import PatientBookTherapySessionPage from "pages/patient/book-therapy-session-page";
import PatientConfirmTherapySessionPage from "pages/patient/confirm-therapy-session-page";
import PatientUpdateTherapySessionPage from "pages/patient/update-therapy-session-page"
import PatientMembershipPackagePage from "pages/patient/membership-package-page";
import { PAGE_ROUTES } from "lib/constants/page-routes";
import useNetworkStatus from "lib/hooks/useNetworkStatus";
import PractitionersManagementPage from "pages/admin/practitioner-management/page";
import PractitionerCheckoutSuccessPage from "pages/practitioner/subscriptions/checkout-success";
import PractitionerCheckoutFailedPage from "pages/practitioner/subscriptions/checkout-failed";
import PractitionerSubscriptionsListPage from "pages/practitioner/subscriptions/practitioner-subscriptions";
import ChangePasswordPage from "pages/authentication/change-password";
import PatientCheckoutSuccessPage from "pages/patient/checkout/checkout-success";
import PatientCheckoutFailedPage from "pages/patient/checkout/checkout-failed";
import PatientPackageCheckoutSuccessPage from "pages/patient/checkout/checkout-package-success";
import PatientSessionCheckoutSuccessPage from "pages/patient/session/checkout-session-success";
import PractitionerPaymentsPage from "pages/practitioner/payments/page";
import AdminPaymentsPage from "pages/admin/payments/page";
import AdminReportsPage from "pages/admin/reports/page";
import RoomsManagementPage from "pages/admin/rooms-management/page";
import { useContext } from "react";
import { AppContext } from "lib/contexts/app-context";
import MaintenancePage from "pages/common/maintenance/page";
import LicenceViewer from "pages/common/licence-viewer/page";
import AdminAddAppoitmentPage from "./pages/admin/practitioner-management/add-appointments";
import AdminEditAppointmentPage from "./pages/admin/patient/edit-book-appointment-page";
import AdminTherapySessionsPage from "./pages/admin/patient/therapy-sessions";
import { SessionBookingProvider } from "lib/contexts/session-booking-context";
import AdminPatientsManagementPage from "pages/admin/patient-management/page";
import AdminAddPatientPage from "pages/admin/patient-management/add-patient";
import AdminPatientProfilePage from "pages/admin/patient-management/patient-profile";
import PatientCheckoutMembershipPackageSuccessPage from "pages/patient/checkout/checkout-membership-package-success";
import PatientCheckoutMembershipPackageFailedPage from "pages/patient/checkout/checkout-membership-package-failed";
import AirpodConsentFormPage from "pages/admin/patient-management/AirpodConsentFormPage";
import CryoChamberFormPage from "pages/admin/patient-management/CryoChamberFormPage";
import InfraredConsentFormPage from "pages/admin/patient-management/InfraredConsentFormPage";
import AdminAirpodConsentFormPage from "pages/admin/patient-management/AdminAirpodConsentFormPage";
import PatientConsentFormPage from "pages/patient/consent-form-page";
import PatientNotesPage from "pages/patient/notes";
import PatientCalenderPage from "pages/patient/calender";
import AdminPatientsCalenderPage from "pages/admin/patients-calender/page";

function App() {
  const { isMaintenanceMode } = useContext(AppContext);
  useNetworkStatus();

  if (isMaintenanceMode) {
    return <MaintenancePage />;
  }

  return (
    <BrowserRouter>
      <SessionBookingProvider>
      <Routes>
        {/* Authentication Routes */}
        <Route path={PAGE_ROUTES.Root} element={<SignIn />} />
        <Route path={PAGE_ROUTES.COMMON.Licence} element={<LicenceViewer />} />
        <Route
          path={PAGE_ROUTES.AUTHENTICATION.Signout}
          element={<SignOut />}
        />

        <Route path={PAGE_ROUTES.AUTHENTICATION.Login} element={<SignIn />} />
        <Route path={PAGE_ROUTES.AUTHENTICATION.SignUp} element={<Signup />} />
        <Route
          path={PAGE_ROUTES.AUTHENTICATION.PractitionerSignUp}
          element={<PractitionerSignup />}
        />
        <Route
          path={PAGE_ROUTES.AUTHENTICATION.ForgotPassword}
          element={<ResetPassword />}
        />
        <Route
          path={PAGE_ROUTES.AUTHENTICATION.UpdatePassword}
          element={<UpdatePassword />}
        />
        <Route
          path={PAGE_ROUTES.AUTHENTICATION.ChangePassword}
          element={<ChangePasswordPage />}
        />

        <Route element={<ProtectedRoute />}>
          {/* Practitioner Routes */}
          <Route
            path={PAGE_ROUTES.PRACTITIONER.Profile}
            element={<ProfilePage />}
          />
          <Route
            path={PAGE_ROUTES.PRACTITIONER.Desert}
            element={<PractitionerDashboard />}
          />
          <Route
            path={PAGE_ROUTES.PRACTITIONER.Dashboard}
            element={<PractitionerDashboard />}
          />

          <Route
            path={PAGE_ROUTES.PRACTITIONER.AppointmentList}
            element={<AppointmentPage />}
          />

          <Route
            path={PAGE_ROUTES.PRACTITIONER.BookAppointment}
            element={<PractitionerAddAppointmentPage />}
          />
          <Route
            path={PAGE_ROUTES.PRACTITIONER.Subscription}
            element={<PractitionerSubscriptionsListPage />}
          />
          <Route
            path={PAGE_ROUTES.PRACTITIONER.BuySubscription}
            element={<PractitionerSubscriptionPage />}
          />
          <Route
            path={PAGE_ROUTES.PRACTITIONER.SubscriptionSuccess}
            element={<PractitionerCheckoutSuccessPage />}
          />
          <Route
            path={PAGE_ROUTES.PRACTITIONER.SubscriptionFailure}
            element={<PractitionerCheckoutFailedPage />}
          />
          <Route
            path={PAGE_ROUTES.PRACTITIONER.Payments}
            element={<PractitionerPaymentsPage />}
          />

          {/* Patient Routes */}
          <Route
            path={PAGE_ROUTES.PATIENT.Desert}
            element={<PatientDashboard />}
          />

          <Route
            path={PAGE_ROUTES.PATIENT.Dashboard}
            element={<PatientDashboard />}
          />

          <Route
            path={PAGE_ROUTES.PATIENT.BookAppointment}
            element={<PatientBookAppointmentPage />}
          />

          <Route
            path={PAGE_ROUTES.PATIENT.ConfirmAppointment}
            element={<PatientConfirmAppointmentPage />}
          />

          <Route
            path={PAGE_ROUTES.PATIENT.BookTherapySession}
            element={<PatientBookTherapySessionPage />}
          />

            <Route
              path={PAGE_ROUTES.PATIENT.ConfirmTherapySession}
              element={<PatientConfirmTherapySessionPage />}
            />

          <Route
            path={PAGE_ROUTES.PATIENT.UpdateTherapySession}
            element={<PatientUpdateTherapySessionPage />}
          />

          <Route
            path={PAGE_ROUTES.PATIENT.MembershipPackage}
            element={<PatientMembershipPackagePage />}
          />

          <Route path={PAGE_ROUTES.PATIENT.Profile} element={<ProfilePage />} />

          <Route
            path={PAGE_ROUTES.PATIENT.BookingSuccess}
            element={<PatientCheckoutSuccessPage />}
          />
          <Route
            path={PAGE_ROUTES.PATIENT.BookingFailure}
            element={<PatientCheckoutFailedPage />}
          />

          <Route
            path={PAGE_ROUTES.PATIENT.CheckoutSuccess}
            element={<PatientPackageCheckoutSuccessPage />}
          />
          <Route
            path={PAGE_ROUTES.PATIENT.CheckoutFailure}
            element={<PatientCheckoutFailedPage />}
          />

          <Route
            path={PAGE_ROUTES.PATIENT.BookSessionSuccess}
            element={<PatientSessionCheckoutSuccessPage />}
          />
          <Route
            path={PAGE_ROUTES.PATIENT.BookSessionFailure}
            element={<PatientCheckoutFailedPage />}
          />

          {/* Admin Routes */}
          <Route path={PAGE_ROUTES.ADMIN.Desert} element={<AdminDashboard />} />
          <Route
            path={PAGE_ROUTES.ADMIN.Dashboard}
            element={<AdminDashboard />}
          />
          <Route
            path={PAGE_ROUTES.ADMIN.DashboardAppointments}
            element={<DashboardAppointmentsPage />}
          />
          <Route
            path={PAGE_ROUTES.ADMIN.DashboardOccupancy}
            element={<DashboardOccupancyPage />}
          />
          <Route
            path={PAGE_ROUTES.ADMIN.DashboardSubscription}
            element={<DashboardSubscriptionPage />}
          />
          <Route
            path={PAGE_ROUTES.ADMIN.UpsertConfigurations}
            element={<UpsertSubscriptions />}
          />

          <Route
            path={PAGE_ROUTES.ADMIN.Configurations}
            element={<ConfigurationsHome />}
          />
          <Route
            path={PAGE_ROUTES.ADMIN.Calendar}
            element={<AdminCalendar />}
          />
          <Route
            path={PAGE_ROUTES.ADMIN.PractitionersManagement}
            element={<PractitionersManagementPage />}
          />
          <Route
            path={PAGE_ROUTES.ADMIN.RoomsManagement}
            element={<RoomsManagementPage />}
          />
          <Route
            path={PAGE_ROUTES.ADMIN.Payments}
            element={<AdminPaymentsPage />}
          />
          <Route
            path={PAGE_ROUTES.ADMIN.Reports}
            element={<AdminReportsPage />}
          />
          <Route
            path={PAGE_ROUTES.ADMIN.BookAppointment}
            element={<AdminAddAppoitmentPage />}
          />
          <Route
            path={PAGE_ROUTES.ADMIN.TherapySessions}
            element={<AdminTherapySessionsPage />}
          />
          <Route
            path={PAGE_ROUTES.ADMIN.PatientsManagement}
            element={<AdminPatientsManagementPage />}
          />
          <Route
            path={PAGE_ROUTES.ADMIN.AddPatient}
            element={<AdminAddPatientPage />}
          />

          <Route
            path={PAGE_ROUTES.ADMIN.PatientProfile}
            element={<AdminPatientProfilePage />}
          />

          <Route
            path={PAGE_ROUTES.ADMIN.ConsentForm}
            element={<AirpodConsentFormPage />}
          />

          <Route
            path={PAGE_ROUTES.ADMIN.CryoChamberForm}
            element={<CryoChamberFormPage />}
          />

          <Route
            path={PAGE_ROUTES.ADMIN.infraredConsentForm}
            element={<InfraredConsentFormPage />}
          />

          <Route
            path={PAGE_ROUTES.ADMIN.AirpodForm}
            element={<AdminAirpodConsentFormPage />}
          />

          <Route
            path={PAGE_ROUTES.ADMIN.PatientsCalender}
            element={<AdminPatientsCalenderPage />}
          />

          <Route
            path={PAGE_ROUTES.ADMIN.EditAppointment}
            element={<AdminEditAppointmentPage />}
          />

          <Route
            path={PAGE_ROUTES.PATIENT.MembershipPackageSuccess}
            element={<PatientCheckoutMembershipPackageSuccessPage />}
          />

          <Route
            path={PAGE_ROUTES.PATIENT.MembershipPackageFailure}
            element={<PatientCheckoutMembershipPackageFailedPage />}
          />

          <Route
            path={PAGE_ROUTES.PATIENT.ConsentForm}
            element={<PatientConsentFormPage />}
          />

          <Route
            path={PAGE_ROUTES.PATIENT.CryoChamberForm}
            element={<CryoChamberFormPage />}
          />

          <Route
            path={PAGE_ROUTES.PATIENT.infraredConsentForm}
            element={<InfraredConsentFormPage />}
          />

          <Route
            path={PAGE_ROUTES.PATIENT.AirpodForm}
            element={<AdminAirpodConsentFormPage />}
          />

          <Route
            path={PAGE_ROUTES.PATIENT.Notes}
            element={<PatientNotesPage />}
          />

          <Route
            path={PAGE_ROUTES.PATIENT.Calender}
            element={<PatientCalenderPage />}
          />

        </Route>
      </Routes>
    </SessionBookingProvider>
    </BrowserRouter>
  );
}

export default App;
